(function () {
    // Early exit if Bootstrap JS is active
    if (window.bootstrap) return;

    // Helper to close all open dropdowns except an optional active one
    const closeAllDropdowns = (exceptDropdown = null) => {
        document.querySelectorAll('.dropdown').forEach(dropdown => {
            if (dropdown === exceptDropdown) return;

            const toggle = dropdown.querySelector('.dropdown-toggle');
            const menu = dropdown.querySelector('.dropdown-menu');

            if (toggle) {
                toggle.setAttribute("aria-expanded", "false");
                toggle.classList.remove("show");
            }
            if (menu) {
                menu.classList.remove("show");
            }
        });
    };

    // Toggle dropdown state
    const toggleDropdown = (toggleEl, dropdownEl) => {
        const isExpanded = toggleEl.getAttribute("aria-expanded") === "true";
        const menuEl = dropdownEl.querySelector('.dropdown-menu');

        // Close other open dropdowns first
        closeAllDropdowns(dropdownEl);

        const nextState = !isExpanded;
        toggleEl.setAttribute("aria-expanded", String(nextState));
        toggleEl.classList.toggle("show", nextState);

        if (menuEl) {
            menuEl.classList.toggle("show", nextState);
        }
    };

    // Delegated click listener
    document.addEventListener("click", (event) => {
        if (window.bootstrap) return;

        const toggleEl = event.target.closest('.dropdown-toggle');

        if (toggleEl) {
            const dropdownEl = toggleEl.closest('.dropdown');
            if (dropdownEl) {
                event.preventDefault();
                toggleDropdown(toggleEl, dropdownEl);
            }
            return;
        }

        // Close dropdowns if clicking outside any open dropdown menu
        if (!event.target.closest('.dropdown-menu')) {
            closeAllDropdowns();
        }
    });

    // Close open dropdowns on Escape key press
    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && !window.bootstrap) {
            closeAllDropdowns();
        }
    });
})();